/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useParams } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';

import { HTTPError } from '@/components/HTTPError';
import BuildConfigRevisionPage from '@/pages/Configs/BuildConfigRevisionPage';

const regex = /^\d+$/;

export function BuildConfigRevisionRoute() {
  const { nodeConfigId } = useParams<'nodeConfigId'>();
  const { configRevisionNumber } = useParams<'configRevisionNumber'>();

  if (!nodeConfigId || !uuidValidate(nodeConfigId)) {
    return <HTTPError httpStatus="404" />;
  }
  if (!configRevisionNumber || !regex.test(configRevisionNumber!)) {
    return <HTTPError httpStatus="404" />;
  }

  return <BuildConfigRevisionPage nodeConfigId={nodeConfigId} configRevisionNumber={Number(configRevisionNumber)} />;
}
